// TODO: Remove this file once the jobs table migration is live
import type { JobWithAuthor } from "@/types"

const mockAuthor = (id: string, username: string, name: string) => ({
  uid: id, username, displayName: name,
  email: "", avatarUrl: "", bio: "", website: "", twitter: "", github: "",
  linkedin: "", reputation: 0, role: "user" as const, createdAt: "", updatedAt: "",
  followerCount: 0, followingCount: 0, postCount: 0, savedPosts: [] as string[], bookmarks: [] as string[],
})

export const MOCK_JOBS: JobWithAuthor[] = [
  {
    id: "mock-1",
    slug: "senior-react-native-engineer-acme",
    authorId: "mock-user",
    title: "Senior React Native Engineer",
    description: "We're looking for a senior React Native engineer to lead mobile development on our flagship consumer app.\n\nResponsibilities:\n• Architect and build new features for our iOS and Android apps\n• Mentor junior developers and conduct code reviews\n• Drive best practices for testing, CI/CD, and performance\n• Collaborate with design and product teams on user experience\n\nRequirements:\n• 5+ years of professional React Native experience\n• Strong TypeScript skills\n• Experience with state management (Redux, Zustand, or similar)\n• Familiarity with native modules and bridging\n• Published apps in the App Store and Google Play\n\nBenefits:\n• Competitive salary ($180k–$240k)\n• Equity package\n• Flexible remote work\n• Health, dental, and vision insurance\n• $2,000 annual learning budget",
    excerpt: "Lead mobile development on our flagship consumer app. Architect new features and mentor junior developers.",
    companyName: "Acme Corp",
    jobType: "full-time",
    location: "San Francisco, CA",
    isRemote: true,
    applyUrl: "https://example.com/apply",
    salaryMin: 180000,
    salaryMax: 240000,
    status: "published",
    viewCount: 342,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    expiresAt: null,
    author: mockAuthor("mock-user", "acme_hiring", "Acme Recruiting"),
  },
  {
    id: "mock-2",
    slug: "react-native-contractor-widget-labs",
    authorId: "mock-user-2",
    title: "React Native Contractor — E-commerce App",
    description: "We're looking for a contractor to build a cross-platform e-commerce app from scratch using React Native and Expo.\n\nProject scope (3 months):\n• Product catalog with search and filtering\n• Shopping cart and checkout flow\n• Stripe payments integration\n• Push notifications for order updates\n• Offline-first architecture with local caching\n\nRequirements:\n• 3+ years React Native experience\n• Experience with Expo managed workflow\n• Stripe or similar payments integration\n• Strong communication skills for async collaboration\n\nRate: Competitive, based on experience. Project starts immediately.",
    excerpt: "3-month contract to build a cross-platform e-commerce app from scratch using React Native and Expo.",
    companyName: "Widget Labs",
    jobType: "contract",
    location: "Austin, TX",
    isRemote: false,
    applyUrl: "https://example.com/apply",
    salaryMin: null,
    salaryMax: null,
    status: "published",
    viewCount: 128,
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    expiresAt: null,
    author: mockAuthor("mock-user-2", "widget_cto", "Sarah Chen"),
  },
  {
    id: "mock-3",
    slug: "mobile-developer-fintech-startup",
    authorId: "mock-user-3",
    title: "Mobile Developer (React Native) — Series A Fintech",
    description: "Join our growing engineering team building the next generation of personal finance tools.\n\nWhat you'll do:\n• Build and maintain our React Native mobile app used by 50k+ users\n• Implement smooth animations with Reanimated and Gesture Handler\n• Work with our GraphQL API and Apollo Client\n• Contribute to our shared component library\n• Participate in on-call rotation for production issues\n\nWhat we're looking for:\n• 3+ years of React Native development\n• Experience with TypeScript and GraphQL\n• Understanding of mobile security best practices\n• Familiarity with financial regulations is a plus\n• Based in NYC or willing to work ET hours\n\nPerks:\n• $140k–$185k salary + equity\n• Hybrid work (2 days in office)\n• Unlimited PTO\n• 401(k) with 4% match",
    excerpt: "Join our growing team building next-gen personal finance tools with React Native, TypeScript, and GraphQL.",
    companyName: "PayFlow",
    jobType: "full-time",
    location: "New York, NY",
    isRemote: true,
    applyUrl: "https://example.com/apply",
    salaryMin: 140000,
    salaryMax: 185000,
    status: "published",
    viewCount: 256,
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    expiresAt: null,
    author: mockAuthor("mock-user-3", "payflow_eng", "PayFlow Engineering"),
  },
  {
    id: "mock-4",
    slug: "freelance-rn-developer-health-app",
    authorId: "mock-user-4",
    title: "Freelance React Native Developer — Health & Wellness App",
    description: "We need a freelance developer to add new features to our existing React Native health tracking app.\n\nFeatures to build:\n• HealthKit (iOS) and Google Fit (Android) integration\n• Interactive charts for activity, sleep, and nutrition data\n• Improved offline sync with conflict resolution\n• Dark mode support\n• Accessibility improvements (VoiceOver, TalkBack)\n\nRequirements:\n• Experience with health/fitness APIs\n• Strong React Native skills with native module experience\n• Ability to work independently with minimal supervision\n• Available 20-30 hours per week\n\nRate: $75–$100/hr depending on experience.",
    excerpt: "Add new features to our health tracking app — HealthKit/Google Fit integration, charts, and offline sync.",
    companyName: "VitalTrack",
    jobType: "freelance",
    location: "Remote",
    isRemote: true,
    applyUrl: "https://example.com/apply",
    salaryMin: 75,
    salaryMax: 100,
    status: "published",
    viewCount: 89,
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    expiresAt: null,
    author: mockAuthor("mock-user-4", "vitaltrack", "Marcus Johnson"),
  },
  {
    id: "mock-5",
    slug: "part-time-rn-instructor",
    authorId: "mock-user-5",
    title: "Part-Time React Native Instructor",
    description: "Teach React Native to bootcamp students in a part-time role.\n\nWhat you'll do:\n• Create and maintain curriculum covering React Native fundamentals through advanced topics\n• Lead 2-3 live coding sessions per week (evenings UK time)\n• Mentor students through their capstone mobile app projects\n• Grade assignments and provide constructive feedback\n• Stay current with React Native ecosystem changes\n\nIdeal candidate:\n• 2+ years of professional React Native experience\n• Previous teaching, mentoring, or public speaking experience\n• Patient and enthusiastic about helping others learn\n• Available 15-20 hours per week\n• Based in UK or compatible timezone\n\nCompensation: £50k–£65k pro-rata + free access to all courses.",
    excerpt: "Teach React Native to bootcamp students — create curriculum, lead live sessions, and mentor projects.",
    companyName: "CodeCamp Academy",
    jobType: "part-time",
    location: "London, UK",
    isRemote: true,
    applyUrl: "https://example.com/apply",
    salaryMin: 50000,
    salaryMax: 65000,
    status: "published",
    viewCount: 201,
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    expiresAt: null,
    author: mockAuthor("mock-user-5", "codecamp", "CodeCamp Academy"),
  },
]
